import { render } from "./NominaPage.vue?vue&type=template&id=10abff7a&scoped=true"
import script from "./NominaPage.vue?vue&type=script&lang=js"
export * from "./NominaPage.vue?vue&type=script&lang=js"

import "./NominaPage.vue?vue&type=style&index=0&id=10abff7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10abff7a"]])

export default __exports__